import { Account } from './account.interfaces';
import { Specimen, SpecimenLocation } from './specimen.interfaces';
import type { StrawRow } from '../../components/embryo-table/EmbryoDetailsTable';
import { StorageLocation } from './inventoryTransaction.interfaces';

export type ExistingEmbryoSpecimen = Specimen & {
  account: Account;
  quantityAvailable: number;
  quantityOwned: number;
  inventoryTransactionId: number | null;
  specimenLocations: SpecimenLocation[];
};

export type AddStrawLevelDataLocation = {
  storageCanisterId: number;
  siteId: number;
  tankId: number;
  siteName: string;
  tankName: string;
  canisterName: string;
  quantity: number;
};

export type AccountStrawState = {
  accountId: number;
  accountName: string;
  specimenId: number;
  currentQuantity: number;
  numStraws: number;
  strawData: StrawRow[];
  storageLocations: StorageLocation[];
};

export enum AddStrawLevelDataModalMode {
  Animal = 'animal',
  Specimen = 'specimen',
}

export type AddStrawModalState = {
  specimenId: number;
};

export type ExistingEmbryoStrawPayload = {
  embryoStrawNumber: string;
  embryoGrade?: string;
  embryoStage: string;
  embryoCountPerStraw: number;
  accountId: number;
  storageCanisterId: number;
};

export type ExistingEmbryoStrawDataPayload = {
  specimenId: number;
  embryoStraws: ExistingEmbryoStrawPayload[];
};
